// composables/api.ts
import { useFetch, useNuxtApp, useRuntimeConfig } from '#app';
import _ from 'lodash';
import moment from 'moment';
import { ENUM } from '~/plugins/constants/enum';
import { LOCAL_STORAGE } from '~/plugins/constants/localStorage';
import { ROUTE } from '~/plugins/constants/route';
import {
  getLocalStorage,
  removeLocalStorage,
} from '~/plugins/functions/localStorage';

export const useApi = async (url: string, configService: any, option?: any) => {
  const runtimeConfig = useRuntimeConfig();
  const { baseUrl, ...fetchOptions } = option || {};
  const resolvedBaseUrl = baseUrl || runtimeConfig.public.apiBase;
  const res = useFetch(`${resolvedBaseUrl}${url}`, {
    ...fetchOptions,
    headers: {
      ...fetchOptions?.headers,
      'x-user-timezone': moment().utcOffset(),
    },
    onRequest(req: any) {
      const accessToken = getLocalStorage(
        LOCAL_STORAGE.OAUTH_BACK_OFFICE_ACCESS_TOKEN
      );
      if (accessToken) {
        req.options.headers.set('Authorization', `Bearer ${accessToken}`);
      }
    },
    onResponseError(err: any) {
      const { $functions } = useNuxtApp();
      // Handle the errponse errors
      console.log('onResponseError', err);
      const res = err.response;
      const resMessage = _.get(res, '_data.message', '');
      const resError = _.get(res, '_data.error', '');
      const resStatusCode = _.get(res, '_data.statusCode', '');

      if (
        resMessage === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED ||
        resError === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED ||
        resStatusCode === ENUM.API_RESPONSE_STATUS.UNAUTHORIZED
      ) {
        console.log('Unauthorized');
        // handleLogout();
        $functions.notify.error({
          text: resMessage,
        });
        removeLocalStorage(LOCAL_STORAGE.OAUTH_BACK_OFFICE_ACCESS_TOKEN);
        window.location.reload();
      } else {
        $functions.notify.error({
          text: resMessage,
        });
      }
    },
  });
  return res;
};

export const useApiFetchSSE = async (
  url: string,
  option?: any
): Promise<Response> => {
  const runtimeConfig = useRuntimeConfig();
    const { baseUrl, ...fetchOptions } = option || {};
    const resolvedBaseUrl = baseUrl || runtimeConfig.public.apiBase;
  const accessToken = getLocalStorage(
    LOCAL_STORAGE.OAUTH_BACK_OFFICE_ACCESS_TOKEN
  );

  const response = await fetch(`${resolvedBaseUrl}${url}`, {
    ...option,
    headers: {
      ...option?.headers,
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-user-timezone': moment().utcOffset(),
    },
    signal: option?.signal,
  });

  if (!response.ok) {
    const { $functions } = useNuxtApp();
    if (response.status === 401) {
      removeLocalStorage(LOCAL_STORAGE.OAUTH_BACK_OFFICE_ACCESS_TOKEN);
      window.location.reload();
    }
    $functions.notify.error({
      text: `HTTP error! status: ${response.status}`,
    });
  }

  return response;
};

export const useApiLogin = async (
  url: string,
  configService: any,
  option?: any
) => {
  const runtimeConfig = useRuntimeConfig();
  const res = useFetch(`${runtimeConfig.public.apiBase}${url}`, {
    ...option,
    headers: {
      ...option?.headers,
      'x-user-timezone': moment().utcOffset(),
    },
    onRequest(req: any) {
      const accessToken = getLocalStorage(
        LOCAL_STORAGE.OAUTH_BACK_OFFICE_ACCESS_TOKEN
      );
      if (accessToken) {
        req.options.headers.set('Authorization', `Bearer ${accessToken}`);
      }
    },
    onResponseError(err: any) {
      const { $functions } = useNuxtApp();
      // Handle the errponse errors
      console.log('onResponseError', err);
      const res = err.response;
      const resMessage = _.get(res, '_data.message', '');
      const resError = _.get(res, '_data.error', '');
      const resStatusCode = _.get(res, '_data.statusCode', '');

      if (
        resMessage === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED ||
        resError === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED ||
        resStatusCode === ENUM.API_RESPONSE_STATUS.UNAUTHORIZED
      ) {
        removeLocalStorage(LOCAL_STORAGE.OAUTH_BACK_OFFICE_ACCESS_TOKEN);
      }
    },
  });
  return res;
};
